// @flow

import type {State} from 'redux/types';
import type {CcState} from 'redux/v1/paymentInsurance/cc/CcState';
import type {DeleteState} from 'redux/v1/paymentInsurance/delete/DeleteState';
import type {EqualTravelState} from 'redux/v1/paymentInsurance/equalTravel/EqualTravelState';
import type {InvoiceState} from 'redux/v1/paymentInsurance/invoice/InvoiceState';
import type {PaymentTypesState} from 'redux/v1/paymentInsurance/paymentTypes/PaymentTypesState';
import type {SelectedPaymentState} from 'redux/v1/paymentInsurance/selectedPayment/SelectedPaymentState';
import type {SepaState} from 'redux/v1/paymentInsurance/sepa/SepaState';

import {paymentInsuranceState} from 'redux/v1/V1State';

export type PaymentInsuranceState = {
  paymentTypes: PaymentTypesState,
  delete: DeleteState,
  cc: CcState,
  sepa: SepaState,
  selectedPayment: SelectedPaymentState,
  equalTravel: EqualTravelState,
  invoice: InvoiceState,
};

export const paymentTypesState = (state: State): PaymentTypesState =>
  paymentInsuranceState(state).paymentTypes;

export const deleteState = (state: State): DeleteState =>
  paymentInsuranceState(state).delete;

export const ccState = (state: State): CcState =>
  paymentInsuranceState(state).cc;

export const sepaState = (state: State): SepaState =>
  paymentInsuranceState(state).sepa;

export const selectedPaymentState = (state: State): SelectedPaymentState =>
  paymentInsuranceState(state).selectedPayment;

export const equalTravelState = (state: State): EqualTravelState =>
  paymentInsuranceState(state).equalTravel;

export const invoiceState = (state: State): InvoiceState =>
  paymentInsuranceState(state).invoice;
